// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"412":"212ed37c","532":"212ed37c","762":"375b5381"}[chunkId] + ".css";
};